import PT from 'prop-types';
import { Link } from 'react-router-dom';
import { QuestionMetadata } from '../../../QuestionMetadata';
import s from './styles.scss';
import { TeacherQuestionItem, StudentQuestionItem } from '../../components';
import urlResolver from 'edrolo/utils/URLResolver';
import { Loader, enums } from 'edrolo-ui';
import { useState, useEffect } from 'react';

export const Question = ({
  question,
  getQuestionInstructionText,
  isTeacher,
  classQuestionSetAggregates,
  questionResponses,
  classId,
  examId,
  buildQuestionSetUrl,
  searchParams,
}) => {
  const [showPerceivedPerformance, setShowPerceivedPerformance] =
    useState(false);

  const questionId = question.get('id').toString();
  const serial = question.get('full_serial');

  const questionInstructionsText = getQuestionInstructionText(
    question.get('id')
  );

  const spicinessLevel = question.get('spiciness_level');
  const workingPathways = question.get('working_pathways')?.toArray();
  const marks = +question.get('marks');
  const skills = isTeacher ? question.get('skills')?.toJS() : undefined;

  const response = questionResponses.get(`${question.get('id')}`);

  const baseUrl = urlResolver.reverse('question-set-question-review', {
    classId,
    examId,
    questionId,
  });

  const teacherLink = `${baseUrl}?${searchParams.toString()}`;
  const studentLink = buildQuestionSetUrl(examId, questionId, classId);

  useEffect(() => {
    setShowPerceivedPerformance(true);
    setTimeout(() => {
      setShowPerceivedPerformance(false);
    }, 300);
  }, [teacherLink, studentLink]);

  if (showPerceivedPerformance) {
    return (
      <div className={s.skeleton}>
        <Loader.Gradient width={enums.Size.MEDIUM} />
        <Loader.Gradient width={enums.Size.LARGE} />
        <Loader.Gradient width={enums.Size.SMALL} />
      </div>
    );
  }

  return (
    <Link
      key={questionId}
      className={s.container}
      to={isTeacher ? teacherLink : studentLink}
    >
      <div className={s.questionTitle}>
        <div className={s.questionSerialText} data-test="question-serial-link">
          Q{serial}
        </div>

        <div className={s.questionInstructionsText}>
          {questionInstructionsText}
        </div>

        <div className={s.questionItem}>
          {isTeacher ? (
            <TeacherQuestionItem
              key={`Q${question.get('id')}`}
              questionId={question.get('id')}
              classQuestionSetAggregates={classQuestionSetAggregates}
            />
          ) : (
            <StudentQuestionItem
              key={`Q${question.get('id')}`}
              answered={response !== undefined}
              grokked={response?.get('grokked')}
            />
          )}
        </div>
      </div>

      <div className={s.questionMetadata}>
        <QuestionMetadata
          marks={marks}
          spicinessLevel={spicinessLevel}
          workingPathways={workingPathways}
          skills={skills}
        />
      </div>
    </Link>
  );
};

Question.propTypes = {
  isTeacher: PT.bool,
  classId: PT.oneOfType([PT.string, PT.number]).isRequired,
  examId: PT.number.isRequired,
  buildQuestionSetUrl: PT.func.isRequired,
  questionResponses: PT.any.isRequired,
  getQuestionInstructionText: PT.func.isRequired,
  classQuestionSetAggregates: PT.any,
  question: PT.object.isRequired,
  searchParams: PT.object.isRequired,
};
